function analyticsConsentGranted() {
  return document.cookie
    .split(';')
    .map(item => item.trim())
    .includes('analytics=true')
}

export function trackAnalyticsEvent(eventName, details = {}) {
  const payload = {
    event: eventName,
    ...details,
  }

  window.dispatchEvent(new CustomEvent('spark:analytics', { detail: payload }))

  if (window.dataLayer && analyticsConsentGranted()) {
    window.dataLayer.push(payload)
  }
}
